<template>
  <div class="BirthDatesForm">
    <h2 class="gl_form-title">
      {{ t('rater.common.more-info.form-legend') }}
    </h2>

    <BirthDatesComponent
      v-model="insureds"
      :for-whom="props.answers.forWhom!"
      :start-date="props.answers.startDate!"
      :relationships="props.configurations.relationships"
      :configurations="configurations"
    />
  </div>
</template>

<script lang="ts" setup>
import { shallowRef } from 'vue'
import type DentalRaterAnswers from '@/modules/dental/rater/models/APP/DentalRaterAnswers'
import { useI18n } from 'vue-i18n'
import Insured from '@/modules/common/common/models/APP/Insured'
import BirthDatesComponent from '@/modules/common/common/components/panels/BirthDatesComponent.vue'
import { UserRoleEnum } from '@/modules/core/models/enums'
defineExpose({ triggerSubmit })

const { t } = useI18n()

interface PropsInterface {
  nextForm: String[]
  answers: DentalRaterAnswers
  configurations: any
  extra?: Record<string, any> | null
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const insureds = shallowRef<Insured[]>(getLoadedInsureds())

function getLoadedInsureds(): Insured[] {
  return props.answers.insureds.length
    ? props.answers.insureds
    : [new Insured({ role: UserRoleEnum.HOLDER_INSURED })]
}

function triggerSubmit() {
  const page = props.nextForm[0]

  const answers = { insureds: insureds.value }
  return { page, answers }
}
</script>
